/**
 * Diskriminanten für den Technical-Error-Screen.
 *
 * Laut Spec gibt es zwei Varianten:
 * - `pinning-failure`: Public-Key-Pinning hat den ausgelieferten Mandanten-Key
 *   abgelehnt — sensibler Sicherheitsfall, eigene Microcopy (DEV-016).
 * - `generic`: alle anderen technischen Fehler (Bootstrap, Netzwerk, Schema,
 *   Crypto-Probleme), die nicht in `business-error` oder `success` münden.
 *
 * In DEV-010 reichen die Diskriminanten — die volle UX-Differenzierung
 * implementiert DEV-016.
 */
export const TechnicalErrorVariant = {
  Generic: 'generic',
  PinningFailure: 'pinning-failure',
} as const;

export type TechnicalErrorVariant =
  (typeof TechnicalErrorVariant)[keyof typeof TechnicalErrorVariant];
